export default "__VITE_ASSET__CsC4a3dL__"